export const injectTrackingScripts = (selectedPlan, plans) => {
  const analyticsEnabled = window.AppENV.analyticsEnabled;
  if (!analyticsEnabled || !selectedPlan) return;

  // Remove existing scripts if they exist
  document
    .querySelectorAll(".tracking-script")
    .forEach((script) => script.remove());

  const selectedPlanData = plans.find((plan) => plan._id === selectedPlan);

  // Meta Pixel Script
  const fbScript = document.createElement("script");
  fbScript.classList.add("tracking-script");
  fbScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '592232429092515');
      fbq('track', 'PageView');
      fbq('track', 'Subscribe', {
        content_category: '${selectedPlanData?.name}',
        value: '${selectedPlanData?.price}',
        currency: '${selectedPlanData?.currency}'
      });
    `;
  document.body.appendChild(fbScript);

  // NoScript Image for Meta Pixel
  const noScript = document.createElement("noscript");
  noScript.innerHTML = `
      <img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=592232429092515&ev=PageView&noscript=1"/>
    `;
  document.body.appendChild(noScript);

  // Google dataLayer
  const gtmScript = document.createElement("script");
  gtmScript.classList.add("tracking-script");
  gtmScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      dataLayer.push({
        ecommerce: null
      });
      dataLayer.push({
        event: "purchase",
        ecommerce: {
          currency: "${selectedPlanData?.currency}",
          value: "${selectedPlanData?.price}",
          items: [{
            item_category: "${selectedPlanData?.title}",
            price: "${selectedPlanData?.price}"
          }]
        }
      });
    `;
  document.body.appendChild(gtmScript);
};
